var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dsf-question-item-box" },
    [
      _vm.subjects.items.value == "group"
        ? [
            _c("div", {
              staticClass: "group-title",
              domProps: { innerHTML: _vm._s(_vm.regHtml) },
              on: { click: _vm.showImage },
            }),
            _vm._l(_vm.subjects.children, function (groupChild, key) {
              return _c(
                "div",
                {
                  key: groupChild.examQuestionsId,
                  attrs: { "child-refs": "key" },
                },
                [
                  _c("dsf-exam-item", {
                    attrs: {
                      "items-type": "group",
                      "show-score": _vm.showScore,
                      "hide-mark": _vm.hideMark,
                      type: _vm.type,
                      previewStatus: _vm.previewStatus,
                      readOnly: _vm.readOnly,
                      subjects: groupChild,
                      "exam-index": key + 1,
                    },
                    on: { "add-show-image": _vm.elimage },
                  }),
                  _c("el-divider"),
                ],
                1
              )
            }),
          ]
        : _c("dsf-exam-item", {
            attrs: {
              "show-score": _vm.showScore,
              "hide-mark": _vm.hideMark,
              type: _vm.type,
              readOnly: _vm.readOnly,
              previewStatus: _vm.previewStatus,
              subjects: _vm.subjects,
              "exam-index": _vm.examIndex + 1,
            },
            on: { "add-show-image": _vm.elimage },
          }),
      _vm.srcList && _vm.srcList.length > 0
        ? _c("el-image", {
            ref: "elimage",
            staticClass: "elimage",
            attrs: { "preview-src-list": _vm.srcList },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }